import { sInputKeyValidationHelper } from '../../shared.min.js';

const cnfsd_lec_calc = (function () {
	let calc,
		form,
		result,
		button,
		restartButton,
		currentYear,
		resultCard,
		bannerStep,
		bannerTitle,
		totalBannerSteps,
		jsonData,
		enterYourAge,
		selectYourBirthSex,
		yearsOldResultText,
		agesBetween;

	async function init() {
		calc = document.getElementById('cnfsd-lec-calc');
		form = calc.querySelector('#cnfsd_lec-form');
		jsonData = form.getAttribute('data-calc-json');
		jsonData = JSON.parse(jsonData);
		result = calc.querySelector('#cnfsd_lec-result');
		button = form.querySelector('button.btn--arrow');
		restartButton = calc.querySelector('a.arrow-link');
		currentYear = new Date().getFullYear();
		resultCard = calc.querySelector('.card--dark');
		bannerStep = calc.querySelector('.banner-current-progress');
		bannerTitle = calc.querySelector('.banner-title');
		totalBannerSteps = 2;
		enterYourAge = calc.querySelector('#enter-your-age').innerHTML;
		selectYourBirthSex = calc.querySelector('#select-your-birth-sex').innerHTML;
		yearsOldResultText = calc.querySelector('#years-old-result-text').innerHTML;
		agesBetween = 'Enter an age between 1 and 90 years old';

		button.addEventListener('click', e => {
			// START FUNCTION
			e.preventDefault();
			showResults();
		});

		restartButton.addEventListener('click', e => {
			// START FUNCTION
			e.preventDefault();
			restartCalc();
		});

		createInputListeners();

		calculateBannerProgress();
	}

	function calculateBannerProgress() {
		const progress = document.querySelector('.banner__progress-bar__bar'),
			//CALC WIDTH OF EACH STEP IN THE PROCESS
			stepWidth = `${(100 / totalBannerSteps) * parseInt(bannerStep.innerHTML)}%`;
		progress.style.width = stepWidth;
	}

	function createInputListeners() {
		const textInputs = form.querySelectorAll('input[type="text"]');
		const radios = form.querySelectorAll('input[type="radio"]');

		//ADD E LISTENER TO REMOVE ERROR ON CHANGE
		radios.forEach(radio => {
			radio.addEventListener('change', () => removeFieldErrors(radio));
		});

		textInputs.forEach(input => {
			sInputKeyValidationHelper(input, 'numeric', input.closest('.field-group'));
		});
	}

	function restartCalc() {
		const radios = form.querySelectorAll('input[type=radio]'),
			textInputs = form.querySelectorAll('input[type=text]'),
			currentLifeExpectancy = resultCard.querySelector('h2.display');

		radios.forEach(input => {
			input.checked = false;
		});

		textInputs.forEach(input => {
			input.value = '';
		});

		//SWAP UI
		swapUi();

		//BANNER PROGRESS
		bannerStep.innerHTML = 1;
		bannerTitle.innerHTML = form.getAttribute('data-title');
		calculateBannerProgress();

		//REMOVE CURRENT CALCULATED LIFE EXPECTANCY
		currentLifeExpectancy.remove();
	}

	function getLifeExpectancy(birthSex, userAge) {
		//GETS THE OBJECT OF THE NEXT 5 YEARS OF LIFE EXPECTANCY
		// Checking to see which gender is selected.
		if (birthSex === 'male') {
			return calculateLifeExpectancy(jsonData.male[userAge], userAge);
		} else {
			return calculateLifeExpectancy(jsonData.female[userAge], userAge);
		}
	}

	function calculateLifeExpectancy(lifeExpectencyObject, userAge) {
		for (const lifeExpectency in lifeExpectencyObject) {
			if (currentYear === parseInt(lifeExpectency, 10)) {
				// Adding on the current age as the json data, gives life expectancy from the current age.
				return Math.floor(lifeExpectencyObject[lifeExpectency] + parseInt(userAge));
			}
		}
	}

	function showResults() {
		const [ageFieldGroup, birthSexFieldGroup] = form.querySelectorAll('.field-group'),
			birthSexChecked = form.querySelectorAll('input:checked'),
			ageInput = document.getElementById('lec-age');

		//THROW ERROR IF SKIPPED INPUTS
		if (
			!birthSexChecked.length ||
			ageInput.value.trim() === '' ||
			parseInt(ageInput.value) > 90 ||
			parseInt(ageInput.value) < 1
		) {
			if (parseInt(ageInput.value) > 90 || parseInt(ageInput.value) < 1)
				throwError(ageFieldGroup, 'lec-age--error', agesBetween);
			if (ageInput.value.trim() === '') throwError(ageFieldGroup, 'lec-age--error', enterYourAge);
			if (!birthSexChecked.length) throwError(birthSexFieldGroup, 'lec-birthsex--error', selectYourBirthSex);
			return;
		}

		const lifeExpectancy = getLifeExpectancy(birthSexChecked[0].value, ageInput.value),
			calcResult = document.createElement('h2');

		//SET LIFE EXPECTANCY
		calcResult.classList.add('display');
		calcResult.innerHTML = getResultYearsOldText(lifeExpectancy);
		resultCard.insertBefore(calcResult, restartButton);

		//SWAP UI
		swapUi();

		//BANNER FUNCTIONALITY
		bannerStep.innerHTML = 2;
		bannerTitle.innerHTML = result.getAttribute('data-title');
		calculateBannerProgress();
	}

	function getResultYearsOldText(lifeExpectancy) {
		return yearsOldResultText.replace('{result}', lifeExpectancy);
	}

	function throwError(fieldset, errorId, errorMessageContent) {
		//IF ERROR EXISTS
		if (fieldset.classList.contains('field-group--error')) return;

		//SET ERROR MESSAGE
		const errorMessage = fieldset.querySelector('.error-message');
		errorMessage.innerHTML = errorMessageContent;
		errorMessage.id = errorId;

		//SET FIELDGROUP TO ERROR CLASS
		fieldset.classList.add('field-group--error');

		//RED BORDERS
		const inputs = fieldset.querySelectorAll('input');
		inputs.forEach(input => {
			input.setAttribute('aria-invalid', true);
			input.setAttribute('aria-errormessage', errorId);
		});
	}

	function removeFieldErrors(input) {
		const fieldGroup = input.closest('.field-group');
		if (!fieldGroup.classList.contains('field-group--error')) return; //IF NO ERROR EXIT FUNCTION
		const inputs = fieldGroup.querySelectorAll('input');
		//REMOVE ERROR MESSAGE
		fieldGroup.classList.remove('field-group--error');

		//REMOVE ATTRIBUTES
		inputs.forEach(input => {
			input.removeAttribute('aria-invalid');
			input.removeAttribute('aria-errormessage');
		});
	}

	function swapUi() {
		result.classList.toggle('display-none');
		form.classList.toggle('display-none');
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	cnfsd_lec_calc.init();
});
